module.exports = {
  "service": {
    "title": "服务条款",
    "content": [{
      "align": "right",
      "text": [{
        "bold":false,
        "content":`最近更新日期：2022年9月28日`
      }]
    },{
      "align": "left",
      "text": [{
        "bold":false,
        "content":`尊敬的用户：
        `
      }]
    },
    {
      "align": "justify",
      "text": [{
        "space": "normal",
        "bold":false,
        "content":`欢迎使用【中广家书】服务（以下简称“中广家书”），为了使您（以下又称“用户”）获得愉悦和安全的服务体验，请务必仔细阅读、充分理解本服务条款全部内容`
      },{
        "space": "normal",
        "bold":true,
        "content":`（特别是粗体标注内容）`
      },{
        "space": "normal",
        "bold":false,
        "content":`。如您不同意本服务条款任意内容，请勿注册或使用中广家书项下服务。如您使用中广家书项下服务，即表示您与中广家书已达成协议，自愿接受本服务条款的所有内容，`
      },{
        "space": "normal",
        "bold":true,
        "content":`特此说明中广家书相关系统、终端设备使用了统一用户认证，相互之间不再需要读取授权，此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。`
      },{
        "space": "pre-line",
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n一、服务条款的确认和范围`
      },{
        "space": "pre-line",
        "bold":false,
        "content":`
        \\r\\n本服务条款是用户与中广家书之间关于其使用中广家书服务所订立的协议。项下各服务内容的所有权、运营权以及相关软件的知识产权均归属于【中广视媒（北京）文化传播有限公司】所有，中广家书提供的服务将完全按照本服务条款和操作规则严格执行。
        \\r\\n“中广家书”是指中广家书服务的经营者。
        \\r\\n“用户”是指中广家书服务的使用人，本服务条款中也称为“您”。
        \\r\\n“中广家书服务”是指中广家书所属平台的一切服务（包括但不限于小程序、公众号、其他客户端、其他服务等）。
        \\r\\n本服务条款由用户与中广家书经共同达成，具有合同效力。
        \\r\\n随着互联网高速发展，为了更好满足您的服务需求，中广家书会在现有本服务条款列明内容的基础上更新补充，丰富服务内容，后续公布的服务条款、隐私政策、法律声明、各单项服务公告等条款规则内容均为本服务条款的补充协议，与本服务条款不可分割且具有同等法律效力。本服务条款的效力范围及于中广家书项下一切产品和服务，您在享受中广家书任何单项服务时，应当受本服务条款的约束。
        \\r\\n请您务必在使用之前认真阅读本服务条款全部内容，如有任何疑问，可联系中广家书咨询。当您通过进入中广家书注册程序使用中广家书，即表示您与中广家书已达成协议，自愿接受本服务条款的所有内容；当您未经中广家书注册程序而使用中广家书服务，亦表示您同意并接受本服务条款的所有内容。当您使用中广家书各单项服务，您的使用行为视为您对单项服务的服务条款以及中广家书在该单项服务中发出的各类更新条款、公告等规则的同意。中广家书对本服务条款的名词定义具有最终解释权。`
      },{
        "space": "normal",
        "bold":false,
        "content":`\\r\\n请用户注意：如果您不同意上述服务条款或其中任何约定，请您立即`
      },{
        "space": "normal",
        "bold":true,
        "content":`停止使用服务。`
      },{
        "space": "pre-line",
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n二、服务简介`
      },{
        "bold":false,
        "content":`
        \\r\\n1、本服务条款所称的中广家书服务平台帐号是指您通过微信、电话号码等授权登录的合法、有效帐号。
        \\r\\n2、中广家书运用自身开发的操作系统通过互联网络为用户提供服务。使用中广家书项下服务，用户必须：
        \\r\\n（1）自行配备上网的所需设备，包括个人手机、平板电脑、调制解调器、路由器等；
        \\r\\n（2）自行负担个人上网所支付的与此服务有关的电话费用、网络费用等；
        \\r\\n（3）选择与所安装终端设备相匹配的系统版本，包括但不限于iOS、Android、iPad、Windows等多个匹配网络的应用系统和版本。
        \\r\\n3、服务费用
        \\r\\n（1）中广家书服务费用主要用于平台纪念堂等功能区维护以及后台运营支持，用户作为功能区管理员可以对所在纪念堂的维护进行续费。
        \\r\\n（2）中广家书服务首次使用年限为一年，后续服务费用根据不同套餐标准收取不同费用；有效期之后中广家书仍会保留纪念堂的功能区信息，再续费时会收取相应的逾期费用。
        \\r\\n中广家书有权对服务费用及所提供内容做出调整，服务费用标准及服务内容与服务项目以实际平台所示内容为准，中广家书会不时根据用户需求及系统操作更新升级。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n三、使用规则`
      },{
        "bold":false,
        "content":`
        \\r\\n1、用户承诺在使用中广家书服务过程中，其为具有完全民事行为能力的民事主体，具有达成交易履行其义务的能力。
        \\r\\n2、用户帐号资料包括但不限于用户的帐号名称、头像、密码、注册或更新帐号时输入的所有信息以及用户使用中广家书各单项服务时输入的名称、头像等所有信息。
        \\r\\n用户在使用中广家书帐号时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在帐号资料中出现违法和不良信息，且用户保证其使用帐号时，不得有以下情形：
        \\r\\n（1）违反宪法或法律法规规定的；
        \\r\\n（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
        \\r\\n（3）损害国家荣誉和利益的，损害公共利益的；
        \\r\\n（4）煽动民族仇恨、民族歧视，破坏民族团结的；
        \\r\\n（5）破坏国家宗教政策，宣扬邪教和封建迷信的；
        \\r\\n（6）散布谣言，扰乱社会秩序，破坏社会稳定的；
        \\r\\n（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
        \\r\\n（8）侮辱或者诽谤他人，侵害他人合法权益的；
        \\r\\n（9）违反中广家书服务相关协议、规定等；
        \\r\\n（10）盗取帐号、诈骗等不正当手段获得用户信息，将户帐号当作商品进行交易（如出售、拍卖用户帐号等）等损害中广家书及用户利益；
        \\r\\n（11）含有法律、行政法规禁止的其他内容的。
        \\r\\n若用户提供给中广家书资料不准确，不真实，含有违法或不良信息的，中广家书有权保留终止用户使用中广家书各项服务的权利。若用户以虚假信息骗取帐号注册或帐号头像、个人简介等注册资料存在违法和不良信息的，中广家书有权采取通知限期改正、暂停使用、注销帐号措施。对于冒用关联机构或社会名人注册帐号名称的，中广家书有权注销该帐号，并向政府主管部门进行报告。
        \\r\\n3、用户个人信息
        \\r\\n（1）根据相关法律、法规规定以及考虑到中广家书产品服务的重要性，用户同意：根据中广家书服务要求提供、更新、补充真实、准确、合法、有效的个人信息。用户同意，其提供的帐号资料是作为认定用户与其中广家书帐号的关联性以及用户身份的唯一证据。用户在享用中广家书各项服务的同时，同意接受中广家书提供的各类信息服务。`
      },{
        "bold":true,
        "content":`
        \\r\\n为使用户及时、全面了解中广家书提供的各项服务，用户同意，中广家书可以多次、长期通过电子邮件、手机短信、邮寄宣传册、微信服务消息推送等形式向用户发送各类信息而无需另行获得用户的同意；如果用户不想收到相关的通讯，可以通过以下方式退阅：
        \\r\\n①在收到商业信息时，根据信息的退订提示退订（如“回复 TD 退订”）
        \\r\\n②前往手机设置，进行免打扰设置。
        \\r\\n（2）用户同意与注册、使用中广家书帐号相关的一切资料、数据和记录，包括但不限于中广家书帐号、个人资料、所有登录和相关的使用统计数字等归中广家书帐号所有。发生争议时，用户同意以中广家书帐号的系统数据为准，中广家书帐号保证该数据的真实性。
        \\r\\n尽管有前述约定，对于用户使用中广家书帐号享受中广家书项下单项服务时产生的一切数据，包括但不限于产品登录记录及其他产品日志、产品客户服务记录、用户在产品中创造的社会网络内容等，归具体产品运营主体所有。发生争议时，用户同意以具体产品运营主体的系统数据为准。但是如果单项条款存在与前述不同的约定，则以单项条款约定为准。`
      },{
        "bold":false,
        "content":`
        \\r\\n4、中广家书通过互联网为您提供网络服务，您应同意以下条款：
        \\r\\n（1）提供准确的个人资料，并及时更新注册资料；
        \\r\\n（2）您将对用户名和密码的安全性负全部责任，并对用户名项下的所有活动负责；
        \\r\\n（3）您对服务的使用应遵守国家法律、地方法规、政策规章及国际法律等；
        \\r\\n（4）您同意保障和维护全体用户的利益，负责支付由于您违反本服务条款引起的律师费用、诉讼费、损害赔偿等费用；
        \\r\\n5、对于用户通过中广家书服务上传到服务平台可公开获取区域的任何内容，用户同意中广家书在全世界范围内具有免费的、永久性的、不可撤销的、非独家和完全再许可的权利，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。
        \\r\\n6、结束服务：
        \\r\\n（1）用户或中广家书可随时根据实际情况中断一项或多项网络服务。中广家书不需对任何个人或第三方负责而随时中断服务。如用户对以后的条款修改有异议，或对中广家书服务不满，可以行使以下权利：
        \\r\\n①停止使用中广家书服务；
        \\r\\n②卸载中广家书服务载体。
        \\r\\n（2）结束用户服务后，用户使用服务的权利马上终止。从结束服务时起，中广家书没有义务传送任何未处理的信息或未完成的服务给用户或第三方。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n四、服务条款的修改
        \\r\\n中广家书有权在必要时通过在网页上发出公告等合理方式单方面修改本服务条款以及各单项服务的相关条款。用户在享受各项服务时，应当及时查阅了解修改的内容，并自觉遵守本服务条款以及该单项服务的相关条款。用户如继续使用本服务条款涉及的服务，则视为对修改内容的同意，当发生有关争议时，以最新的服务条款为准；用户在不同意修改内容的情况下，有权停止使用本服务条款涉及的服务。
        \\r\\n
        \\r\\n五、服务的变更
        \\r\\n中广家书始终在不断变更和改进服务。中广家书在发展中会根据客观环境及用户需求增加或删除功能，也可能暂停或彻底停止某项服务。用户同意中广家书有权行使上述权利且不需对用户或第三方承担任何责任。
        \\r\\n
        \\r\\n六、用户隐私制度
        \\r\\n尊重用户隐私是中广家书的一项基本政策。中广家书将按照中广家书公布的隐私政策收集、存储、使用、披露和保护用户的个人信息。请您完整阅读上述隐私政策，以帮助您更好地保护您的个人信息。中广家书在必要时可单方面修改隐私政策，用户应及时阅读并遵守相关内容。
        \\r\\n
        \\r\\n七、用户帐号安全性`
      },{
        "space": "normal",
        "bold":false,
        "content":`
        \\r\\n用户可以结束旧的帐号重开一个新帐号。用户应维持帐号安全，如果用户未保管好自己的帐号和密码而对用户、中广家书或任何第三方造成损害，用户将负全部责任。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，有义务立即通告中广家书。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n八、不可抗力条款
        \\r\\n中广家书对不可抗力导致的损失不承担责任。本服务条款所指不可抗力包括但不限于天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。
        \\r\\n
        \\r\\n九、禁止服务的商业化
        \\r\\n用户承诺，未经中广家书同意，用户不能利用中广家书各项服务进行销售或其他商业用途。如用户有需要将服务用于商业用途，应书面通知中广家书并获得中广家书的明确授权。
        \\r\\n
        \\r\\n十、用户管理`
      },{
        "bold":false,
        "content":`
        \\r\\n用户独立承担其发布内容的责任。用户使用中广家书服务必须遵守所有适用于服务的地方法律、国家法律和国际法律。用户承诺：
        \\r\\n（1）用户在中广家书网页上发布信息或者利用中广家书服务时必须符合中国有关法律法规，不得在中广家书网页上或者利用中广家书服务制作、复制、发布、传播以下信息：
        \\r\\n(a) 违反宪法确定的基本原则的；
        \\r\\n(b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
        \\r\\n(c) 损害国家荣誉和利益的；
        \\r\\n(d) 煽动民族仇恨、民族歧视，破坏民族团结的；
        \\r\\n(e) 破坏国家宗教政策，宣扬邪教和封建迷信的；
        \\r\\n(f) 散布谣言，扰乱社会秩序，破坏社会稳定的；
        \\r\\n(g) 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
        \\r\\n(h) 侮辱或者诽谤他人，侵害他人合法权益的；
        \\r\\n(i) 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；
        \\r\\n(j) 以非法民间组织名义活动的；
        \\r\\n(k) 含有法律、行政法规禁止的其他内容的。
        \\r\\n（2）用户在中广家书网页上发布信息或者利用中广家书服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。用户需遵守法律法规的规定使用中广家书项下服务。
        \\r\\n（3）用户不得利用中广家书的服务从事以下活动：
        \\r\\n(a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；
        \\r\\n(b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；
        \\r\\n(c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；
        \\r\\n(d) 故意制作、传播计算机病毒等破坏性程序的；
        \\r\\n(e) 其他危害计算机信息网络安全的行为。
        \\r\\n（4）用户不得以任何方式干扰中广家书服务。
        \\r\\n（5）用户不得滥用中广家书服务，包括但不限于：利用中广家书提供的服务发送垃圾邮件，利用中广家书服务进行侵害他人知识产权或者合法利益的其他行为。
        \\r\\n（6）用户应遵守中广家书的所有其他规定和程序。
        \\r\\n用户须对自己在使用中广家书服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在中广家书首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予中广家书等额的赔偿。若用户违反以上规定，中广家书有权作出独立判断立即暂停或终止对用户提供部分或全部服务，包括锁定、注销、删除用户中广家书帐号等措施。用户理解，如果中广家书发现其网站传输的信息明显属于上段第(1)条所列内容之一，依据中国法律，中广家书有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n十一、保障
        \\r\\n用户同意保障和维护中广家书全体成员的利益，承担由用户违反本服务条款的损害补偿费用，其它人使用用户的电脑、帐号而产生的费用。
        \\r\\n如用户或其它网络服务提供者利用中广家书服务侵害他人权益的，应当承担相应法律责任。
        \\r\\n如用户利用中广家书服务实施侵权行为的，被侵权人有权通知中广家书采取删除、屏蔽、断开链接等必要措施。中广家书接到通知后，因自身过错若未及时采取必要措施的，按法律规定承担责任。
        \\r\\n
        \\r\\n十二、通知`
      },{
        "bold":false,
        "content":`
        \\r\\n所有发给用户的通知都可通过电子邮件、通知或在网站显著位置公告等方式进行传送。中广家书将通过上述方法之一将消息传递给用户，告知他们本服务条款的修改、服务变更、或其它重要事情。同时，中广家书保留利用中广家书发布商业性广告的权利，包括但不限于在中广家书的登录页面及登录后任何页面内放置商业广告、向中广家书的用户发送商业性广告邮件以及在中广家书的用户发出的电子邮件内附上商业性广告及／或广告链接等形式。
        \\r\\n中广家书会通过通知公告或电子邮件或手机短信传送等方式，把通告传送给用户，该等通告于发送之日即视为已送达收件人。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n十三、知识产权`
      },{
        "bold":false,
        "content":`
        \\r\\n1、中广家书服务中的所有内容，包括但不限于所有文字、图片、图形、音频、视频等都归属于中广家书，均受版权、商标和其他财产所有权法律的保护。未经中广家书同意，任何企业或个人均无权复制、下载、传输、再造本程序任何内容，也不得提供给任何第三方使用，否则应负所有法律责任。违反上述声明而给本公司造成损失的，本公司将依法追究其法律责任。用户只能在中广家书授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。
        \\r\\n2、中广家书服务使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经相关软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）等行为。
        \\r\\n3、中广家书尊重知识产权并注重保护用户享有的各项权利。在中广家书帐号所含服务中，用户可能需要通过上传、发布等各种方式向中广家书提供内容。在此情况下，用户仍然享有此等内容的完整知识产权。用户在提供内容时将授予中广家书一项全球性的免费许可，允许中广家书使用、传播、复制、修改、再许可、翻译、创建衍生作品、出版、表演及展示此等内容。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n十四、免责声明`
      },{
        "bold":false,
        "content":`
        \\r\\n1、用户清楚使用中广家书服务所存在的任何风险，并承诺对其产生的一切后果负责。
        \\r\\n2、中广家书不保证服务满足所有用户的所有需求，也不保证服务不会中断，对服务的及时性、安全性、出错发生均不作保证。
        \\r\\n3、中广家书对于因不可抗力或本程序不能控制的原因造成的【中广家书】服务中断或其他缺陷，中广家书及【中广视媒（北京）文化传播有限公司】不承担任何责任，但会尽力协助处理以减少因此给用户造成的损失。
        \\r\\n4、由于用户自己将验证码告知他人或验证码泄露、手机或其他设备被盗、与他人共享微信登录帐号、转借或出让帐号给他人使用等其他原因导致任何个人信息的泄露，均由用户自行承担相关法律责任和经济损失，中广家书及【中广视媒（北京）文化传播有限公司】无需承担任何责任。
        \\r\\n5、由于用户向中广家书提供错误、不完整、不实信息等造成不能正常使用本程序服务或遭受任何其他损失，中广家书及【中广视媒（北京）文化传播有限公司】无需承担任何责任。
        \\r\\n6、中广家书不保证所有由【中广家书】发出的短信不会发生遗失或未送达。由于短信运营商网络运转问题、天灾人祸、战争等原因造成网络瘫痪或者接收短信的用户手机网络通道不畅通等不可抗力因素，而导致短信无法即时、准确地送达用户，中广家书及【中广视媒（北京）文化传播有限公司】无须承担相应责任。
        \\r\\n7、中广家书及其内容以用户提供资料以现有资料为基础，平台只提供【中广家书】服务，因此并不会因程序内容引起的任何损失而作直接、间接、意外、衍生性及惩罚性的损害赔偿（包括金钱利益及无形的损失）及承担法律责任。
        \\r\\n8、中广家书会提供其他网站的链接，这些链接的网站并非由中广家书控制，故不对该网站的内容、其链接网站的内容及其内容的更新及转变承担任何责任，这些网站的使用及内容也不代表【中广家书】的立场。
        \\r\\n9、用户使用登录的微信ID是用户身份的唯一标识，手机号是授权工作人员提供服务的唯一服务凭证，如手机号码发生变动，请及时修改。如因用户自身原因未及时修改手机号而造成的服务无法提供等损失，中广家书将不承担相关责任，但会尽力协助用户处理以减少因此给用户造成的影响。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n十五、争议解决
        \\r\\n本服务条款的订立、执行、解释及争议解决均应适用中国法律并受中国法院管辖。
        \\r\\n如发生本服务条款与中国法律相抵触时，则这些条款将完全按法律规定重新解释，不影响其它合法条款对用户产生的法律效力和影响。
        \\r\\n如双方就本服务条款内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，用户和中广家书一致同意将纠纷交由北京市朝阳区有管辖权人民法院受理。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。
        \\r\\n
        \\r\\n十六、信息储存`
      },{
        "bold":false,
        "content":`
        \\r\\n中广家书对项下服务将尽力维护其安全性及方便性，但对服务中用户帐号项下的信息（包括但不限于用户发布的信息）删除或储存失败不承担任何责任。另外中广家书有权判定用户的行为是否符合本服务条款的要求，如果用户违背了本服务条款的规定，中广家书有权中止或者终止对其中广家书帐号的服务。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n十七、青少年用户特别提示`
      },{
        "bold":false,
        "content":`
        \\r\\n青少年用户必须遵守全国青少年网络文明公约：
        \\r\\n要善于网上学习，不浏览不良信息；要诚实友好交流，不侮辱欺诈他人；要增强自护意识，不随意约会网友；要维护网络安全，不破坏网络秩序；要有益身心健康，不沉溺虚拟时空。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n十八、帐号服务有效期`
      },{
        "bold":false,
        "content":`
        \\r\\n用户清楚知悉中广家书帐号下管理的纪念堂存在有效期，并不定时登录使用中广家书帐号、按时为中广家书服务缴纳费用以延续其有效期。`
      },{
        "bold":true,
        "content":`
        \\r\\n
        \\r\\n十九、其他`
      },{
        "bold":false,
        "content":`
        \\r\\n（1）中广家书不行使、未能及时行使或者未充分行使本条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响中广家书在将来行使该权利。
        \\r\\n（2）如本条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力，中广家书及用户均应尽力使该条款设定的本意得到实现。
        \\r\\n（3）本条款中的标题仅为方便而设，不作为解释本条款的依据。
        \\r\\n如用户对本条款内容有任何疑问，可通过【中广家书客服】给我们提建议。`
      }]
    }]
  },
  "privicy": {
    "title": "隐私政策",
    "content": [{
        "align": "right",
        "text": [{
          "bold":false,
          "content":`最近更新日期：2022年9月28日`
        }]
      },
      {
        "align": "justify",
        "text": [{
          "space": "pre-line",
          "bold": false,
          "content": `尊敬的用户：`
        },{
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n欢迎使用【中广家书】服务（以下简称“中广家书”），为了使您（以下又称“用户”）获得愉悦和安全的服务体验，请务必仔细阅读、充分理解《【中广家书】隐私政策》（以下简称本政策）全部内容`
        },{
          "space": "normal",
          "bold": true,
          "content": `（特别是粗体标注内容）。`
        },{
          "space": "normal",
          "bold": false,
          "content": `如您不同意本隐私政策或其中任何约定，请勿注册或使用中广家书项下服务。如您使用中广家书项下服务，即表示您与中广家书已达成协议，可以依据本政策来处理您的个人信息。如您对本政策有任何疑问，您可以联系【中广家书】。`
        },{
          "space": "pre-line",
          "bold": false,
          "content": `
          \\r\\n
          \\r\\n特别提示：`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n本政策仅适用于您所适用的【中广视媒（北京）文化传播有限公司】（以下简称“中广视媒”）提供的【中广家书】相关服务。【中广家书】非常重视保护用户的个人信息。在您使用【中广家书】的服务前，请务必仔细阅读并理解本政策`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `（尤其是粗体内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可通过本政策提供的联系方式咨询我们。`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `当您使用【中广家书】的服务时，或在本政策更新后继续使用【中广家书】的服务，即视为您已经阅读、理解并同意本政策及其更新的版本，同意我们按照本政策的约定处理您的个人信息。如您不同意本政策的任何条款，请您立即停止使用【中广家书】的服务。`
        },
        {
          "bold": false,
          "content": `
          \\r\\n
          \\r\\n本政策将帮助您了解以下内容：
          \\r\\n1、我们如何收集和使用您的个人信息
          \\r\\n2、我们如何使用Cookie和同类技术
          \\r\\n3、我们如何共享、转让、公开披露您的个人信息
          \\r\\n4、我们如何保护和保存您的个人信息
          \\r\\n5、您的权利
          \\r\\n6、我们如何处理儿童的个人信息
          \\r\\n7、本政策如何更新
          \\r\\n8、如何联系我们
          \\r\\n
          \\r\\n一、我们如何收集和使用您的个人信息`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `
          \\r\\n个人信息`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
          `
        },
        {
          "space": "normal",
          "bold": true,
          "content": `
          \\r\\n个人敏感信息`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `是指一旦泄露、非法提供或者滥用可能危及人身和财产安全、极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。`
        },
        {
          "bold": false,
          "content": `
          \\r\\n【中广家书】仅会出于本政策所述的以下目的，收集和使用您的个人信息：
          \\r\\n（一）核心业务功能收集和使用您个人信息的情形
          \\r\\n我们可能会收集、保存和使用下列与您有关的信息才能实现下述功能。如果您不提供相关信息，您将无法享受相关的【中广家书】服务。这些功能包括：
          \\r\\n1、帐号注册、登录与验证
          \\r\\n为完成创建帐号，您至少需提供以下信息（统称“帐号信息”）：您的微信ID、手机号、帐号名称/昵称、帐号名、密码等，我们将通过微信授权验证您的身份是否有效；您还可以补充您的地区以及您的实名认证相关信息，这些信息均属于您的“帐号信息”。您补充的信息将有助于我们为您提供个性化的服务体验，但如果您不提供这些补充信息，不会影响您使用【中广家书】服务的基本功能。
          \\r\\n
          \\r\\n2、服务展示和搜索`
        },
        {
          "bold": true,
          "content": `
          \\r\\n为了让您快速地找到您所需要的服务内容，我们可能会收集您使用我们的产品与/或服务的设备信息（包括设备名称、设备型号、MAC地址及IMEI、设备识别码、移动应用列表等软硬件特征信息、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN）等）、设备所在位置相关信息（包括您授权的GPS位置信息以及WLAN接入点、蓝牙信息等）、浏览器类型等，以为您提供商品信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。如果您不想看到推荐的服务等信息，您可以通过提示选择屏蔽相关服务类目。`
        },
        {
          "bold": false,
          "content": `
          \\r\\n您也可以通过搜索来精准地找到您所需要的服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的服务。`
        },
        {
          "bold": true,
          "content": `
          \\r\\n请您注意，单独的设备信息、浏览器类型或仅搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何目的对其进行使用；只有当您的单独的设备信息、浏览器类型或搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的设备信息、浏览器类型或搜索关键词信息作为您的个人信息，按照本政策对其进行处理与保护。`
        },
        {
          "bold": false,
          "content": `
          \\r\\n3、服务管理`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n当您准备对购买服务进行结算时，系统会生成您购买该服务的订单。`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `您可能需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品服务信息、下单时间、您应支付的商品金额及支付方式等；您可以另外填写收货人的联系电话、邮箱地址信息以增加更多的联系方式确保商品可以准确送达，但不填写这些信息不影响您订单的生成。若您需要开具发票，还需要提供发票抬头、纳税人识别号以及接收发票电子邮箱等信息。`
        },
        {
          "bold": false,
          "content": ``
        },
        {
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n上述所有信息构成您的`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `“订单信息”`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。`
        },
        {
          "bold": false,
          "content": `
          \\r\\n4、支付结算`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n在您下单后，您可以选择本程序支持的支付服务。支付功能本身并不收集您的个人信息，`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `但我们需要您的服务订单号与交易金额信息，包括支付途径（微信、支付宝、苹果支付等），支付必要信息与这些支付机构共享以实现确认您的支付指令并完成支付。
          `
        },
        {
          "bold": false,
          "content": `
          \\r\\n在您联系客服申请提供发票时，还需您提供以下信息：发票抬头、纳税人识别号、收票人电话、邮箱地址，如您申请纸质发票，则还需要提供您的姓名、电话、收件地址以及根据您的开票要求提供的更多信息。同时，我们会收取不同程度的寄送运费。
          \\r\\n5、消息推送
          \\r\\n我们收集您的设备信息，用于向您提供服务。为避免干扰您日常工作和生活，您可以在手机或其他设备的“设置”或在APP等进行免打扰设置。
          \\r\\n6、客服与售后
          \\r\\n我们的客服和售后功能会使用您的帐号信息和订单信息。
          \\r\\n为保证您的帐号安全，我们的呼叫中心客服和在线客服会使用您的帐号信息核验您的身份。当您需要我们提供相关客服及售后服务时，我们将会查询您的服务信息。您将可能会在与我们的客服人员沟通时，提供相关信息（姓名、性别、年龄、邮箱、地址、电话等）进行身份核对。
          \\r\\n7、改善我们的产品或服务
          \\r\\n我们可能会将收集的您的帐号信息、服务信息进行保存最后一次历史记录。
          \\r\\n对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为你提供一致的服务。我们可能会将来自某项服务的信息与其他服务的信息、合法间接获取的信息及合法公开渠道获取的信息结合，或者将合法获取您的可识别个人信息与无法识别的个人信息结合，为您提供个性化服务及改善我们的产品和服务。
          \\r\\n8、保障交易安全
          \\r\\n为保障您使用我们服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护帐号安全，我们可能会通过您的浏览信息、服务信息、您常用的软件信息、设备信息等手段来判断您的帐号风险，并可能会记录一些我们认为有风险的链接（“URL”）。我们也会收集您的设备信息对【中广家书】系统问题进行分析、统计流量并排查可能存在的风险，在您选择向我们发送异常信息时予以排查。如果您不提供上述信息，我们则无法在您使用【中广家书】过程中对您的服务及帐号安全进行保护。
          \\r\\n（二）附加业务功能收集和使用您个人信息的情形
          \\r\\n我们可能从第三方获取您授权共享的帐号信息，并在您同意本政策后将您的第三方帐号与您的【中广家书】帐号绑定，使您可以通过第三方帐号直接登录并使用【中广家书】的服务。
          \\r\\n如我们从我们的合作伙伴获取您的个人信息，我们将依据与第三方的约定，对个人信息来源的合法性进行确认后，在符合相关法律法规的前提下，使用您的这些个人信息。
          \\r\\n（三）其他用途
          \\r\\n1、【中广家书】可能会以电子邮件、手机短信等方式向您发送【中广家书】认为您可能会感兴趣的广告和其它商业信息。
          \\r\\n2、我们通过技术手段对收集的您的个人信息进行去标识化处理后，去标识化处理的信息将无法识别主体，您知悉并同意，我们有权使用已经去标识化的信息。在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。
          \\r\\n3、我们会对我们服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
          \\r\\n4、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。
          \\r\\n5、当我们要将您的个人信息用于本政策未载明的其他用途时，或基于特定目的收集而来的信息用于其他目的时，会通过在线点击授权或邮件、短信等形式事先征求您的同意。
          \\r\\n（四）征得同意的例外
          \\r\\n您充分知悉，在以下情形中，我们收集、使用个人信息无需征得您的授权同意：
          \\r\\n1、与国家安全、国防安全有关的；
          \\r\\n2、与公共安全、公共卫生、重大公共利益有关的；
          \\r\\n3、与犯罪侦查、起诉、审判和判决执行有关的；
          \\r\\n4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          \\r\\n5、所收集的个人信息是个人信息主体自行向社会公众公开的；
          \\r\\n6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
          \\r\\n7、根据您的要求签订和履行合同所必需的；
          \\r\\n8、用于维护所提供的服务的安全稳定运行所必需的，如处理发现、处置服务的故障等问题；
          \\r\\n9、为合法的新闻报道所必需的；
          \\r\\n10、为配合相关部门机关调查所必需的；
          \\r\\n11、法律法规规定的其他情形。
          \\r\\n根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
          \\r\\n（五）您个人信息使用的规则
          \\r\\n1、我们会根据本政策的约定并为实现我们的服务功能对所收集的个人信息进行使用。`
        },
        {
          "space": "normal",
          "bold": false,
          "content":`
          \\r\\n2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。
          `
        },
        {
          "bold": false,
          "content": ``
        },
        {
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n3、`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `您了解并同意，您在使用我们的服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的服务期间持续授权我们使用。
          `
        },
        {
          "bold": false,
          "content": `
          \\r\\n4、我们会对我们的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
          \\r\\n5、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n6、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `请您理解，我们向您提供的服务将不断更新变化。如果您选择使用本政策中尚未列明的其他服务时，我们会在收集您的个人信息前通过协议、页面提示等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。若您不同意提供前述信息，您可能无法使用该项服务，但不影响您使用现有服务。`
        },
        {
          "bold": true,
          "content": ``
        },
        {
          "bold": false,
          "content": `
          \\r\\n
          \\r\\n二、我们如何使用Cookie和同类技术
          \\r\\n（一）Cookie
          \\r\\n为确保本程序正常运转，我们会在您的计算机或移动设备商存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。
          \\r\\n我们不会将Cookie用于本政策所述目的之外的任何用途。您可以根据自己的偏好管理或删除Cookie。大部分网络浏览器会自动接受Cookie，但您可根据自己的需要来修改浏览器的设置以阻止 Cookie；另外，您可以清除计算机上保存的所有 Cookie 。但如果您这么做，您可能需要在每一次访问我们的程序时亲自更改用户设置，而且可能会对您所使用服务的安全性有一定影响。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
          \\r\\n（二）网站信标和像素标签
          \\r\\n除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
          \\r\\n（三）Do Not Track（请勿追踪）
          \\r\\n很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我们的所有网站都会尊重您的选择。
          \\r\\n
          \\r\\n三、我们如何共享、转让、公开披露您的个人信息
          \\r\\n（一）共享
          \\r\\n1、我们不会与【中广视媒（北京）文化传播有限公司】及其关联公司以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：
          \\r\\n（1）在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；
          \\r\\n（2）我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息；
          \\r\\n（3）在法律法规允许的范围内，为维护【中广家书】或合作伙伴、您或其他【中广家书】用户或社会公众利益、财产或安全免遭损害而有必要提供；
          \\r\\n（4）只有共享您的信息，才能实现我们的服务的核心功能或提供您需要的服务；
          \\r\\n（5）应您需求为您处理您与他人的纠纷或争议；
          \\r\\n（6）符合与您签署的相关协议（包括在线签署的电子协议）或其他的法律文件约定所提供；
          \\r\\n（7）基于学术研究而使用；
          \\r\\n（8）基于符合法律法规的社会公共利益而使用。
          \\r\\n2、为实现基于本程序向您提供相关服务，向您展示可能感兴趣的内容，保护您的帐号与交易安全，我们可能会将您的个人信息与我们的关联公司共享：您的个人信息可能会与【中广家书】的关联公司共享。我们只会共享必要的个人信息，且受本政策所声明目的约束。关联公司如要改变您个人信息处理目的，将再次征求您的授权同意。
          \\r\\n我们的关联公司是指：不时控制【中广视媒（北京）文化传播有限公司】或其实体、或被【中广视媒（北京）文化传播有限公司】或其实体所控制、或与【中广视媒（北京）文化传播有限公司】或其实体被共同控制之下的任何实体，其中“控制”指直接或间接具备或控制50%以上投票权。
          \\r\\n3、与授权合作伙伴共享：
          \\r\\n仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们只会共享提供服务所必要的个人信息，我们的合作伙伴无权将共享的个人信息用于任何其他用途。
          \\r\\n我们的关联公司与我们适用同样的数据合规管理制度、本政策及相关保密和安全措施。对我们与之共享个人信息的我们的关联公司之外的公司、组织和个人，我们会与其签署严格的保密协定/数据处理协议，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。
          \\r\\n（二）转让
          \\r\\n我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
          \\r\\n1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
          \\r\\n2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意；
          \\r\\n3、符合与您签署的相关协议（包括在线签署的电子协议）或其他的法律文件约定所提供；
          \\r\\n4、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供。
          \\r\\n（三）公开披露
          \\r\\n我们仅在以下情况，且采取符合业界标准的安全防护措施的前提下，公开披露您的个人信息：
          \\r\\n1、获得您的明确同意后；
          \\r\\n2、基于法律的披露：根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
          \\r\\n
          \\r\\n四、我们如何保护和保存您的个人信息
          \\r\\n（一）我们保护您个人信息的技术与措施
          \\r\\n1、我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。
          \\r\\n2、 我们成立了数据安全管理组织，采取个人信息在物理（门禁隔离、监控系统等）、管理（制定信息安全体系制度、将数据分类分级、与员工签订保密协议、开展数据安全和隐私保护培训、定期开展合规自评估等）和技术（通过 https安全浏览方式确保传输加密、采用AES256加密技术确保数据存储加密、敏感信息内容展示脱敏、匿名化处理、系统访问部署了双因素认证访问控制机制、自动化代码检查、日志审计等）等方面的安全保障措施努力保护您的个人信息不被未经授权地访问、使用、披露、修改、损坏或丢失及其它的形式的非法处理。
          \\r\\n3、我们会定期组织安全应急预案演练，防止安全事故发生。如不幸发生我们知悉所获取并储存的数据安全受到危害时，或由于外部行为使用户的非公开信息被披露给不相关第三方时，尽管本政策中有其他免责规定，我们也会启动应急预案，组成紧急应急小组，启动流程，进行内部调查、上报并通知监管部门、配合监管部门工作，降低事故对用户的影响，同时会在认为适当的情况下采取推送通知、邮件、公告等形式告知相关用户，告知其被披露的信息以及我们对该等情况的知悉程度。
          \\r\\n（二）个人信息的保存期限
          \\r\\n1、 您的个人信息及帐号内相关权益、虚拟资产信息将在您注销帐号后立即删除，不可恢复。
          \\r\\n2、为满足您的查询需要，您的服务信息在我们前台系统将保留到付费服务产品的有效期。满足该期限后，我们将有权对您的服务信息进行删除或匿名化处理。
          \\r\\n3、您的个人信息将在我们后台系统保存更长的期限，具体期限根据个人信息的类型、法律法规要求和满足本政策所述目的确定。
          \\r\\n4、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
          \\r\\n
          \\r\\n五、您的权利
          \\r\\n按照中国相关的法律、法规、标准，我们保障您对自己的个人信息行使以下权利：
          \\r\\n（一）访问您的个人信息
          \\r\\n您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
          \\r\\n帐号信息——如果您希望访问或编辑您的帐号中的个人资料信息，您可以使用您的帐号和密码登录查询您注册时提供的个人信息。
          \\r\\n（二）更正您的个人信息
          \\r\\n当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“【中广家书】”中罗列的方式更正您的相关信息。
          \\r\\n（三）删除您的个人信息
          \\r\\n在以下情形中，您可以向我们提出删除个人信息的请求：
          \\r\\n1、如果我们处理个人信息的行为违反法律法规；
          \\r\\n2、如果我们收集、使用您的个人信息，却未征得您的同意；
          \\r\\n3、如果我们处理个人信息的行为违反了与您的约定；
          \\r\\n4、如果您不再使用我们的产品或服务，或您注销了帐号；
          \\r\\n5、如果我们不再为您提供产品或服务。
          \\r\\n若我们决定响应您的删除请求，我们还将同时尽可能通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
          \\r\\n（四）改变您授权同意的范围或撤回您的授权
          \\r\\n请您理解，每个业务功能需要一些基本的个人信息才能得以完成（见本政策“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。
          \\r\\n您可以通过删除信息、关闭设备功能、在App等进行隐私设置、在您的设备中设置或关闭相关权限（见本政策“第一部分”-“（二）附加业务功能收集和使用您个人信息的情形”）改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销帐号的方式，撤回我们继续收集您个人信息的全部授权。
          \\r\\n当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
          \\r\\n如果您不想接受我们给您发送的商业广告，您随时可通过以下方式取消：
          \\r\\n无论您基于何种原因拒绝相关信息，您可以在收到营销信息时，根据信息中的退订提示要求我们不再向您发送营销信息，我们会尊重您的请求。
          \\r\\n（五）个人信息主体注销帐号
          \\r\\n您可以登录帐号后在注销帐号页面提交注销申请。在注销帐号之后，我们将删除您的帐号信息，法律法规另有规定的除外。
          \\r\\n当纪念堂只有您一位管理员时，在您注销帐号时，点击确定即表示您已同意平台删除您管理的纪念堂；当纪念堂有多位管理员时，在您注销帐号时，点击确定即表示您已同意并授权您上传到纪念堂的资料移交给当前主办人进行编辑、删除等管理。
          \\r\\n当前主办人有权对纪念堂的管理员进行移除，当您被当前主办人移除纪念堂后，您在纪念堂上传的资料由当前主办人进行管理。
          \\r\\n（六）响应您的上述请求
          \\r\\n为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
          \\r\\n我们将在三十天内做出答复。
          \\r\\n对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
          \\r\\n在以下情形中，按照法律法规要求，我们将无法响应您的请求：
          \\r\\n1、与国家安全、国防安全直接相关的；
          \\r\\n2、与公共安全、公共卫生、重大公共利益直接相关的；
          \\r\\n3、与犯罪侦查、起诉、审判和判决执行等直接相关的；
          \\r\\n4、有充分证据表明您存在主观恶意或滥用权利的；
          \\r\\n5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
          \\r\\n6、涉及商业秘密的；
          \\r\\n7、其他有可能侵害第三方利益的情形。
          \\r\\n
          \\r\\n六、我们如何处理儿童的个人信息`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `
          \\r\\n我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，`
        },
        {
          "space": "normal",
          "bold": true,
          "content": `应事先取得您监护人的同意。`
        },
        {
          "space": "normal",
          "bold": false,
          "content": `我们的服务主要面向成人。如果没有父母或监护人的同意，儿童不得使用我们的产品、服务。我们将不满14周岁的任何人均视为儿童。`
        },
        {
          "bold": false,
          "content": `
          \\r\\n对于经父母同意而收集儿童个人信息的情况，我们只会在法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
          \\r\\n如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
          \\r\\n
          \\r\\n七、本政策如何更新
          \\r\\n为给您提供更好的服务以及随着我们业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本程序上发布对本政策所做的任何变更。
          \\r\\n对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件或短信发送通知，说明隐私政策的具体变更内容）。
          \\r\\n本政策所指的重大变更包括但不限于：
          \\r\\n1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
          \\r\\n2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
          \\r\\n3、个人信息共享、转让或公开披露的主要对象发生变化；
          \\r\\n4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
          \\r\\n5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
          \\r\\n6、个人信息安全影响评估报告表明存在高风险时。
          \\r\\n我们还会将本政策的旧版本存档，供您查阅。
          \\r\\n
          \\r\\n八、如何联系我们
          \\r\\n如果您对本隐私政策或您个人信息的相关事宜有任何疑问、意见或建议，请联系【中广家书客服】
          \\r\\n`
        }]
      }
    ]
  }
  }


// WEBPACK FOOTER //
// ./src/pages/pay/content.js